
export const common = {
  '请求延时': 'Atraso na solicitação',
  '操作成功': 'Operação bem-sucedida',
  '暂无数据': 'Sem dados disponíveis',
  '请输入': 'Por favor, insira',
  'copyok': 'Copiado com sucesso',
  'copyerror': 'Falha ao copiar',
  };
  export const tableList = {
    '跟单交易量':'Volume de Cópias de Negociação',
    '跟单总交易量':'Volume total de cópias negociadas',
    '持仓': 'Posições Abertas',
    '仓位': 'Tamanho da Posição',
    '当前委托': 'Ordens Ativas',
    '当前计划': 'Planos Ativos',
    '历史仓位': 'Histórico de Posições',
    '账单': 'Histórico Financeiro',
    '全部平仓': 'Fechar Todas as Posições',
    '全部撤单': 'Cancelar Todas as Ordens',
    用户昵称: "Apelido de usuário",
    '合约名称': 'Nome do Contrato',
    '创建时间': 'Data de Criação',
    '方向': 'Direção',
    '杠杆': 'Alavancagem',
    '保证金': 'Margem',
    '开仓价格': 'Preço de Abertura',
    '开仓均价': 'Preço Médio de Abertura',
    '全仓风险率': 'Taxa de Risco da Posição',
    '预估爆仓价': 'Preço Estimado de Liquidação',
    '收益率': 'Taxa de Retorno',
    '平仓价格': 'Preço de Fechamento',
    '预计强平价': 'Preço Estimado de Encerramento',
    '持仓数量': 'Quantidade da Posição',
    '张': 'Contratos',
    '风险率': 'Taxa de Risco',
    '保证金率': 'Taxa de Margem',
    '预计止盈价': 'Preço Estimado de Take Profit',
    '预计止损价': 'Preço Estimado de Stop Loss',
    '浮动盈亏': 'Lucro/Prejuízo Não Realizado',
    '平仓盈亏': 'Lucro/Prejuízo Realizado',
    '盈亏': 'Lucro/Prejuízo Total',
    '委托数量': 'Quantidade da Ordem',
    '委托价格': 'Preço da Ordem',
    '成交价格': 'Preço de Execução',
    '成交均价': 'Preço Médio de Execução',
    '止盈价': 'Preço de Take Profit',
    '止损价': 'Preço de Stop Loss',
    '执行价': 'Preço de Execução',
    '触发条件': 'Condição de Disparo',
    '操作': 'Ação',
    '手续费': 'Taxa de Transação',
    '平仓类型': 'Tipo de Encerramento',
    '类型': 'Tipo',
    '数量': 'Quantidade',
    
    '逐仓做多': 'Longo (Cross)',
    '逐仓做空': 'Curto (Cross)',
    '全仓做多': 'Longo (Isolado)',
    '全仓做空': 'Curto (Isolado)',
    '永续合约': 'Contrato Perpétuo',
    
    '手动平仓': 'Encerrar Manualmente',
    '市价平仓': 'Encerrar no Preço de Mercado',
    '限价平仓': 'Encerrar com Limite de Preço',
    '止盈': 'Take Profit',
    '止损': 'Stop Loss',
    '手动撤销': 'Cancelar Manualmente',
    '自动减仓': 'Auto Redução',
    '强制减仓': 'Redução Forçada',
    '强制平仓': 'Liquidação Forçada',
    '资金不足系统撤单': 'Ordem Cancelada por Falta de Fundos',
    '资金超限系统撤单': 'Ordem Cancelada por Exceder Limites',
    '撤单': 'Cancelar',
    '平仓': 'Fechar Posição',
    '更多': 'Mais',
    '部分平仓': 'Fechar Parcialmente',
    '反向开仓': 'Abrir Posição Reversa',
    '加仓': 'Adicionar Posição',
    '一键平仓': 'Fechar Tudo',
    '最新价': 'Preço Atual',
    '体验金平仓': 'Fechar em 24 Horas',
    '下单时间': 'Data e Hora da Ordem',
    '交易类型': 'Tipo de Transação',
    '委托类型': 'Tipo de Ordem',
    '成交类型': 'Tipo de Execução',
    '逐仓平多': 'Fechar Longo (Cross)',
    '逐仓开多': 'Abrir Longo (Cross)',
    '逐仓平空': 'Fechar Curto (Cross)',
    '逐仓开空': 'Abrir Curto (Cross)',
    '全仓平多': 'Fechar Longo (Isolado)',
    '全仓开多': 'Abrir Longo (Isolado)',
    '全仓平空': 'Fechar Curto (Isolado)',
    '全仓开空': 'Abrir Curto (Isolado)',
    '可平量为0': 'Quantidade de Fechamento é 0',
    '激活价格': 'Preço de Ativação',
    '状态': 'Status',
    '未激活': 'Não Ativado',
    '已激活': 'Ativado',
    '回调率': 'Taxa de Retorno',
    '仓位ID': 'ID da Posição',
  };

export const dialog = {
  前往设置: 'Ir para Configurações',
  提示: 'Dica',
  确定: 'Confirmar',
  取消: 'Cancelar',
  确认要全部平仓吗: 'Tem certeza de que deseja fechar todas as posições a preço de mercado e cancelar todas as ordens?',
  确认要全部撤单吗: 'Tem certeza de que deseja cancelar todas as ordens?',
  确认要一键平仓吗: 'Tem certeza de que deseja fechar todas as posições?',
  确认要一键平仓: 'Tem certeza de que deseja fechar todas as posições e encerrar a cópia?',
  确认要市价平仓吗: 'Tem certeza de que deseja fechar a posição a preço de mercado?',
  确认要限价平仓吗: 'Tem certeza de que deseja fechar a posição a preço limite?',
  需先设置总跟单账户: 'Você deve configurar uma conta mestre antes de habilitar a cópia.',
  加仓: 'Adicionar Posição',
  不能为空: 'Não pode ficar em branco',
  必须为数字值: 'Deve ser um valor numérico',
  数字不能小于等于0: 'O número não pode ser menor ou igual a 0',
  请输入正确的杠杆倍数: 'Por favor, insira uma alavancagem válida',
  无法切换仓位模式: 'Não é possível mudar o modo de posição',
  当前账户没有权限: 'A conta atual não possui permissões',
  swap001: 'Você tem posições abertas e não pode mudar o modo de posição',
  需全部平仓后可重新设置: 'Você precisa fechar todas as posições antes de modificar o valor de cópia e a alavancagem',
  按张数: 'Por Quantidade',
  按金额: 'Por Valor',
  按比例: 'Por Porcentagem',
  按价格: 'Por Preço',
  张: 'Contratos',
  预计加仓金额: 'Valor estimado para adição de posição',
  预计加仓张数: 'Quantidade estimada para adição de posição',
  持仓数量: 'Quantidade em Posição',
  开仓价格: 'Preço de Abertura',
  确认要反向开仓吗: 'Tem certeza de que deseja abrir uma posição contrária?',
  预计平仓金额: 'Valor estimado para fechamento',
  预计平仓比例: 'Porcentagem estimada para fechamento',
  预计平仓张数: 'Quantidade estimada para fechamento',
  比例不可以大于: 'A porcentagem não pode ser maior que',
  比例不可以小于: 'A porcentagem não pode ser menor que',
  部分平仓: 'Fechar Parcialmente',
  确认撤单吗: 'Tem certeza de que deseja cancelar a ordem?',
  确认要平仓吗: 'Tem certeza de que deseja fechar a posição?',
  盈亏: 'Lucro/Prejuízo',
  当前止损价: 'Preço Atual de Stop Loss',
  预估止损价: 'Preço Estimado de Stop Loss',
  亏损: 'Prejuízo',
  止损修改: 'Modificar Stop Loss',
  止损比例: 'Porcentagem de Stop Loss',
  止损价格: 'Preço de Stop Loss',
  当前盈利价: 'Preço Atual de Take Profit',
  预估止盈价: 'Preço Estimado de Take Profit',
  收益: 'Lucro',
  止盈修改: 'Modificar Take Profit',
  止盈比例: 'Porcentagem de Take Profit',
  止盈价格: 'Preço de Take Profit',
  请输入加仓数: 'Por favor, insira a quantidade para adição de posição',
  请输入金额: 'Por favor, insira o valor',
  请输入止盈价格: 'Por favor, insira o preço de Take Profit',
  请输入止盈比例: 'Por favor, insira a porcentagem de Take Profit',
  请输入止损价格: 'Por favor, insira o preço de Stop Loss',
  请输入止损比例: 'Por favor, insira a porcentagem de Stop Loss',
  
  'BTC/USDT账户模式': 'Modo de Conta BTC/USDT',
  账户模式: 'Modo de Conta',
  调整仓位模式: 'Ajustar Modo de Posição',
  保证金模式: 'Modo de Margem',
  仓位模式: 'Modo de Posição',
  调整保证金模式: 'O ajuste de margem afetará todos os contratos futuros USDT',
  调整仓位合并模式: 'O ajuste de posição afetará todos os contratos futuros USDT',
  全仓模式: 'Modo Cross',
  仓位合并: 'Combinar Posições',
  逐仓: 'Modo Isolado',
  全仓: 'Modo Cross',
  合仓: 'Combinar Posições',
  分仓: 'Dividir Posições',
  swap002:
  'No modo isolado, você pode ter posições longas e curtas independentes, e a liquidação afetará apenas a margem da posição. Se você liquidar manualmente, os lucros e perdas de posições longas e curtas serão liquidados separadamente para a margem da posição correspondente.',
  全仓模式下所有仓位将共享合约账户的可用保证金: 'No modo Cross, todas as posições compartilharão a margem disponível na conta de contrato. Em caso de liquidação forçada, todas as posições e margem disponível podem ser perdidas. Tenha cuidado com o risco de posição!',
  合仓提示: '',
  分仓提示: '',
  不再提示: 'Não mostrar novamente',
  
  biking合约用户使用协议: 'Contrato Biking - Acordo do Usuário',
  综述:
  '<b>1. Introdução</b><br><br>' +
  '<span>' +
  '1.1 O Contrato Perpétuo ("este serviço") é um derivativo de ativos virtuais lançado pela "Biking". É responsabilidade da "Biking" projetar e gerenciar o produto, bem como operar a plataforma de negociação para este serviço.' +
  '<br><br>' +
  '1.2 Para usar o Contrato Perpétuo da "Biking", você deve ler e cumprir o Contrato do Usuário do Contrato Perpétuo da "Biking". Por favor, leia cuidadosamente todos os termos deste acordo e escolha aceitá-lo ou rejeitá-lo. Seu uso deste serviço e a aceitação deste acordo indicam que você leu, compreendeu e concorda em cumprir os termos deste acordo.' +
  '</span>' +
  '<br><br>' +
  '<b>2. Qualificação para usar este serviço</b>' +
  '<br><br>' +
  '<span>2.1 Você entende e concorda que:' +
  '<br>' +
  'Você concordou em cumprir os "Termos de Serviço da Biking" e possui qualificação e não está proibido de usar os "serviços" definidos neles;' +
  '<br>' +
  'Este acordo não entra em conflito com as leis do seu país ou região;' +
  '<br>' +
  'Você é o proprietário legítimo dos ativos virtuais depositados neste serviço e garante que a origem desses ativos virtuais é legal.' +
  '<br><br>' +
  '2.2 Você entende os riscos de usar este serviço, incluindo, entre outros:' +
  '<br>' +
  'As flutuações de preço significativas dos ativos virtuais e seus derivativos podem resultar em perdas substanciais ou totais em um curto período de tempo;' +
  '</span>',
  我已阅读并同意上述协议: 'Eu li e concordo com o Contrato do Usuário acima',
  
  调整杠杆: 'Ajustar Alavancagem',
  杠杆倍数: 'Alavancagem',
  当前杠杆倍数最大可开: 'Alavancagem atual máxima permitida para abertura:',
  '当前仓位所需保证金：': 'Margem necessária para a posição atual:',
  
  交易单位切换: 'Alternar Unidade de Negociação',
  成交类型切换: 'Alternar Tipo de Execução',
  限价: 'Limite',
  市价: 'Mercado',
  数字范围必须在: 'O número deve estar entre 1 e 100',
  请输入平仓数: 'Digite a quantidade para fechamento',
  请输入平仓比例: 'Digite a porcentagem para fechamento',
  请输入整数: 'Digite um número inteiro',
  以当前最优价格交易: 'Negociar pelo preço ótimo atual',
  请输入格式正确的杠杆倍数: 'Digite uma alavancagem no formato correto',
  杠杆倍数提示: 'A alavancagem atual é alta; por favor, esteja ciente do risco.',
  下单二次确认: 'Confirmação Dupla para Ordens',
  平仓二次确认: 'Confirmação Dupla para Fechamento de Posição',
  下单确认: 'Confirmação de Ordens',
  二次确认不展示: 'Não mostrar a confirmação dupla novamente (você pode reativar em "Preferências")',
  切换交易单位: 'Alternar Unidade de Negociação',
  偏好设置: 'Preferências',
  仓位止盈止损: 'Take Profit e Stop Loss',
  移动止盈止损: 'Mover Take Profit e Stop Loss',
  止盈止损提示:
  'A ordem móvel de Take Profit e Stop Loss é usada para fechar a posição. Se o mercado se mover favoravelmente, para proteger os lucros do negociante, quando o mercado retorna, as ordens pré-definidas são enviadas para o mercado como ordens de stop. Quando o preço de mercado atinge o preço de ativação definido, a ordem é ativada. Quando o preço de mercado atinge o preço máximo (mínimo) definido pelo negociante após a ordem ter sido ativada, a ordem de fechamento é executada com base no preço máximo (mínimo) definido pelo negociante.',
  最新成交价: 'Último Preço',
  设置止盈: 'Definir Take Profit',
  设置止损: 'Definir Stop Loss',
  预计盈利: 'Lucro Estimado',
  预计亏损: 'Prejuízo Estimado',
  调整保证金: 'Ajustar Margem',
  增加: 'Aumentar',
  减少: 'Diminuir',
  最大: 'Máximo',
  当前仓位保证金: 'Margem Atual da Posição',
  最大可增加: 'Máximo Aumento Permitido',
  最大可减少: 'Máximo Redução Permitida',
  调整后参考强评价: 'Preço de Liquidação de Referência após o Ajuste',
  请输入保证金: 'Por favor, digite a margem',
  强平价格: 'Preço de Liquidação',
  开仓数量: 'Quantidade da Posição',
  计算: 'Calcular',
  计算结果: 'O resultado do cálculo é apenas uma referência',
  回调率: 'Taxa de Retorno',
  请输入回调率: 'Por favor, digite a taxa de retorno',
  仓位数量: 'Quantidade da Posição',
  激活价: 'Preço de Ativação',
  请输入激活价: 'Por favor, digite o preço de ativação',
  激活做多提示: 'Preço de ativação para Long deve ser maior do que o preço atual de mercado',
  激活做空提示: 'Preço de ativação para Short deve ser menor do que o preço atual de mercado',
};

export const codeInfo = {
  永续合约: 'Contrato Perpétuo',
  标记价格: 'Preço de Marcação',
  指数价格: 'Preço do Índice',
  指数价格提示:
  'O preço de índice em tempo real deste contrato. Este preço é usado no cálculo do preço de liquidação estimado das posições dos usuários e pode ter algumas diferenças em relação ao preço mais recente de negociação do contrato, a fim de evitar manipulação de preço.',
  '24H最高': 'Maior Valor em 24 Horas',
  '24H最低': 'Menor Valor em 24 Horas',
  资金费率: 'Taxa de Financiamento Atual',
  距费用结算: 'Tempo até a Próxima Liquidação de Taxas',
  我的赠金: 'Meus Bônus',
};

export const panKou = {
  交易深度: 'Profundidade do Mercado',
  实时成交: 'Negociações em Tempo Real',
  张: 'Contratos',
  保证金: 'Margem',
  价格: 'Preço',
  数量: 'Quantidade',
  时间: 'Hora',
  累计: 'Total',
};

export const placeOrder = {
  立即去玩:"立即去玩",
  全仓: 'Full',
  逐仓: 'Cross',
  杠杆: 'Leverage',
  开多: 'Comprar Longo',
  开空: 'Vender Curto',
  市价委托: 'Ordem de Mercado',
  限价委托: 'Ordem Limitada',
  计划委托: 'Ordem de Stop',
  价格: 'Preço',
  数量: 'Quantidade',
  限价: 'Limite',
  市价: 'Mercado',
  止盈止损: 'Take Profit / Stop Loss',
  张: 'Contratos',
  开仓价: 'Preço de Abertura',
  触发价: 'Preço de Acionamento',
  执行价: 'Preço de Execução',
  
  收益: 'Lucro',
  按比例设置: 'Configurar por Porcentagem',
  按价格设置: 'Configurar por Preço',
  亏损: 'Prejuízo',
  
  swap003: 'Comprar/Vender Longo',
  swap004: 'Vender/Comprar Curto',
  买入: 'Comprar',
  卖出: 'Vender',
  做多: 'Longo',
  做空: 'Curto',
  可用: 'Disponível',
  可做多: 'Disponível para Comprar Longo',
  可做空: 'Disponível para Vender Curto',
  
  资产: 'Ativos',
  持仓保证金: 'Margem de Posição',
  未实现盈亏: 'Lucro Não Realizado',
  净值: 'Patrimônio Líquido',
  可用保证金: 'Margem Disponível',
  账户余额: 'Saldo da Conta',
  风险率: 'Taxa de Risco',
  
  合约信息: 'Informações do Contrato',
  指数来源: 'Fonte do Índice',
  合约面值: 'Valor do Contrato',
  资金费率: 'Taxa de Financiamento',
  最大杠杆: 'Alavancagem Máxima',
  下单方向可开张数的: 'Número de Contratos Abertos na Direção da Ordem',
  
  立即注册: 'Registrar Agora',
  登录: 'Entrar',
  swap005: 'Ativos (Contratos Perpétuos)',
  登录以查看: 'Faça login para ver',
  
  请输入数量: 'Digite a Quantidade',
  请输入价格: 'Digite o Preço',
  请输入限价: 'Digite o Preço Limite',
  请输入止盈止损: 'Digite a Take Profit / Stop Loss',
  '止损率不能大于90%': 'A taxa de Stop Loss não pode ser superior a 90%',
  止损价格不能大于: 'O preço de Stop Loss não pode ser maior que',
  开通合约账号: 'Abrir Conta de Contratos',
  账号冻结: 'Conta Congelada',
  '止盈率不能大于1000%': 'A taxa de Take Profit não pode ser superior a 1000%',
  请输入触发价: 'Digite o Preço de Acionamento',
  保证金: 'Margem',
  体验金: 'Bônus',
  不使用体验金: 'Não Usar Bônus',
  查看详情: 'Ver Detalhes',
  委托保证金: 'Margem da Ordem',
  币: 'Moeda',
  计算器: 'Calculadora',
  划转: 'Transferir',
};

export const codelist = {
  搜索: 'Buscar',
  全部: 'Todos',
  交易对: 'Par de Negociação',
  最新价: 'Último Preço',
  涨幅: 'Variação',
  自选: 'Favoritos',
  添加自选成功: 'Adicionado aos Favoritos com Sucesso',
  取消自选成功: 'Removido dos Favoritos com Sucesso',
};

export const merchandiser = {
  跟单数据统计: 'Estatísticas de cópia de negociação',
  我的实盘: "Minha Conta Real",
  与优秀的交易员共同赚钱: "Ganhe Dinheiro com Traders Experientes",
  code_00051: "Comunidade de Copy Trading",
  个人中心: "Área Pessoal",
  更多服务: "Mais Serviços",
  钱包: "Carteira",
  衍生品: "Derivativos",
  跟单设置: "Configuração de Copiagem",
  跟单: "Copiar Conta",
  跟单提示: "Os dados são atualizados a cada hora",
  我的跟单: "Minha Copiagem",
  成为交易员: "Tornar-se Trader",
  综合排名: "Classificação Geral",
  收益率: "Taxa de Retorno",
  近3周收益: "Retorno nas últimas 3 semanas",
  近3周胜率: "Taxa de Vitória nas últimas 3 semanas",
  总收益: "Retorno Total",
  累计收益率: "Retorno Acumulado",
  累计跟随人数: "Número Total de Seguidores",
  跟随中: "Copiando",
  AUM: "AUM",
  当前跟谁: "Copiando para",
  搜索交易员: "Buscar Traders",
  满员: "Completo",
  申请成为交易员: "Solicitar Tornar-se Trader",
  手机号: "Número de Celular",
  邮箱: "E-mail",
  请输入邮箱: "Insira seu e-mail",
  邮箱错误: "E-mail inválido",
  请输入手机号: "Insira seu número de celular",
  手机号错误: "Número de celular inválido",
  请输入正确数值: "Insira um valor válido",
  申请交易员提示文案: "Ao se tornar um Trader, você pode receber uma parte dos lucros das cópias de sua conta.",
  跟单确认: "Confirmação da Copiagem",
  我已同意跟单协议: "Eu li e concordo com o Acordo de Copiagem",
  跟单协议: "《Acordo de Copiagem》",
  申请跟单提示文案: "Este acordo é celebrado entre você (referido como 'você' ou 'seu') e o Biking. Ao acessar, utilizar qualquer serviço fornecido pela plataforma Biking ou qualquer um de seus sites afiliados, incluindo o site oficial wang.com e aplicativos móveis, e outros serviços relacionados fornecidos por qualquer entidade afiliada do Biking (a seguir referido como 'Serviços'), você declara que leu, entendeu e aceitou todos os termos e condições estabelecidos neste Contrato de Utilização (a seguir referido como 'Contrato') e qualquer termo e condição adicional publicado na plataforma.",
  申请跟单提示文案1: "1. Seguir as ordens de negociação de um Trader pode envolver riscos de perda. Tais riscos são de responsabilidade do usuário seguidor;",
  申请跟单提示文案2: "2. A plataforma Biking permite que os seguidores copiem as contas de Traders usando a opção 'Isolada'. Caso o seguidor queira abrir posições por conta própria, ele pode usar a opção 'Cross' na conta de Contratos Futuros, sem afetar a conta de cópias.",
  申请跟单提示文案3: "3. Após seguir um Trader, somente as novas posições do Trader serão copiadas, e as posições existentes não serão copiadas. Os seguidores podem cancelar a cópia a qualquer momento. O cancelamento da cópia não fechará as posições copiadas, mas o seguidor pode fechá-las manualmente;",
  申请跟单提示文案4: "4. Ajustar a posição de cópia pode fazer com que o seguidor saia do modo de cópia;",
  申请跟单提示文案5: "5. Se a cópia das ordens do Trader resultar em lucros, 12% do lucro será concedido ao Trader como recompensa.",
  申请跟单提示文案6: "6. Seguir as ordens do Trader pode envolver riscos de perda. Escolha com cuidado e esteja ciente dos riscos de copiar negociações.",
  申请跟单提示文案7: "7. Se as ordens do Trader forem determinadas como violação das regras e sua identidade como Trader for cancelada, você não poderá seguir novas posições, mas suas posições copiadas permanecerão inalteradas e você sairá do modo de cópia.",
  申请跟单提示文案8: "8. O Trader tem o direito de remover seguidores. Se você for removido, não poderá seguir novas posições, mas suas posições copiadas permanecerão inalteradas.",
  搜索您的国家名或国家区号: "Digite o nome do seu país ou código de área",
  我已同意成为交易员: "Eu concordo em me tornar um Trader",
  请勾选: "Por favor, selecione",
  申请交易员失败提示: "Você está atualmente copiando contas e não pode se tornar um Trader no momento. Por favor, pare todas as cópias antes de aplicar.",
  我知道了: "Entendi",
  今日收益: "Lucro Hoje",
  累计收益: "Lucro Total",
  交易员分成: "Lucro do Trader",
  待结算分成: "Lucro a ser Liquidado",
  已结算分成: "Lucro Liquidado",
  当前跟单: "Cópias Atuais",
  历史跟单: "Histórico de Cópias",
  我的交易员: "Meus Traders",
  编辑: "Editar",
  平仓均价: "Preço Médio de Fechamento",
  持仓均价: "Preço Médio de Abertura",
  开仓时间: "Hora de Abertura",
  平仓时间: "Hora de Fechamento",
  预估暴仓价: "Preço de Liquidação Estimado",
  交易员: "Trader",
  详情: "Detalhes",
  仓位ID: "ID da Posição",
  空位提醒: "Aviso de Vaga",
  空位提醒内容: "O Trader atingiu o limite máximo de seguidores. Um lembrete será enviado quando o Trader não estiver com a vaga completa.",
  当前跟随: "Copiando Atualmente",
  跟随人数数据: "{v1}/{v2} pessoas",
  跟随人数: "Número de Seguidores",
  总权益: "Saldo Total",
  带单合约: "Contrato Copiado",
  交易数据: "Dados de Negociação",
  交易笔数: "Número de Negociações",
  盈利笔数: "Número de Negociações com Lucro",
  亏损笔数: "Número de Negociações com Prejuízo",
  扛单比例: "Taxa de Autoresponsabilidade",
  平均扛单率: "Taxa Média de Autoresponsabilidade",
  最大扛单率: "Taxa Máxima de Autoresponsabilidade",
  订单: "Ordens",
  跟随者: "Seguidores",
  跟随者收益: "Lucro dos Seguidores",
  跟随用户: "Usuários que Copiam",
  跟随总额: "Total Copiado",
  跟随收益: "Lucro da Copiagem",
  交易员订单本金: "Saldo do Trader na Posição",
  当前带单: "Conta Real Copiada Atualmente",
  历史带单: "Conta Real Copiada Anteriormente",
  不用了: "Cancelar",
  设置提醒成功: "Notificação configurada com sucesso",
  我的带单: "Minhas Cópias",
  查看主页: "Ver Página",
  利润分成比例: "Taxa de Divisão de Lucro",
  跟随交易员: "Copiar Trader",
  仓位类型: "Tipo de Posição",
  指定杠杆: "Alavancagem Específica",
  请输入杠杆: "Insira a alavancagem",
  单笔倍率: "Multiplicador por Ordem",
  单笔金额: "Valor por Ordem",
  固定额度: "Valor Fixo",
  请输入单笔金额1: "Insira um valor fixo não inferior a 5U",
  请输入单笔金额: "Insira um valor por ordem de {v1} a {v2}",
  请输入单笔倍率: "Insira o multiplicador de cópias de {v1} a {v2}",
  每次下单折合U: "A cada posição aberta, serão utilizados {v1} USDT como margem",
  每次下单倍数: "A quantidade por ordem é {v1} vezes a quantidade de ordem do Trader",
  倍率: "Multiplicador",
  跟单本金: "Capital de Copiagem",
  总跟单保证金: "Margem Total Copiada",
  请输入跟单本金: "Insira o capital de cópias",
  资产账户: "Conta de Ativos {v1} USDT",
  合约账户: "Conta de Contratos {v1} USDT",
  风险控制: "Controle de Risco",
  设置: "Configuração",
  保存: "Salvar",
  取消跟随: "Cancelar Copiagem",
  移除跟随: "Remover Copiagem",
  交易员保证金: "Margem do Trader",
  请输入交易员保证金: "Insira a margem do Trader",
  风险设置提示: "Quando o capital de cópia atinge este valor, a copiagem será encerrada",
  关闭带单: "Desativar Copiagem",
  我的跟随者: "Meus Seguidores",
  带单设置: "Configuração de Copiagem",
  预计利润分成: "Lucro Estimado a Ser Dividido",
  利润分成: "Divisão de Lucro",
  开启成功: "Ativado com sucesso",
  开启失败: "Falha ao ativar",
  关闭成功: "Desativado com sucesso",
  关闭失败: "Falha ao desativar",
  确认取消吗: "Tem certeza de que deseja cancelar a copiagem?",
  条件一: "Contrato sem posição, ordens atuais, ordens planejadas",
  条件二: "Saldo disponível em contrato ≥ {v} USDT",
  条件三: "Contrato sem posição",
  最大回撤: "Máxima Retração",
  平均持仓时间: "Tempo Médio de Posição",
  正在跟随: "Copiando",
  历史跟随: "Histórico de Copiagem",
  累计跟单: "Total Copiado",
  累计分成: "Total Dividido",
  笔: "negociações",
  上一页: "Página Anterior",
  下一页: "Próxima Página",
  返回: "Voltar",
  今日预估收益: "Lucro Estimado Hoje",
  账户权益: "Patrimônio da Conta",
  将账户权益展示在个人信息页面: "Exibir o patrimônio da conta na página de informações pessoais",
  带单本金: "Capital de Copiagem",
  每次开仓均会展示带单本金: "O capital de copiagem será exibido em todas as ordens abertas",
  隐藏挂单价:'Ocultar preço do pedido pendente',
  带单币对: "Par de Contratos Copiados",
  入住时间: "Data de Entrada",
  保存成功: "Salvo com sucesso",
  取消成功: "Cancelado com sucesso",
  设置成功: "Configurado com sucesso",
  跟单合约: "Contrato Copiado",
  历史委托: "Ordens Anteriores",
  成交数量: "Quantidade Negociada",
  触发时间: "Hora de Acionamento",
  开启带单: "Ativar Copiagem",
  账户已冻结: "Conta congelada, por favor, contate o suporte",
  审核中: "Em Análise",
  小时: "{v} horas",
  累计分润: "Total Dividido",
  今日预估分润: "Lucro Estimado Hoje",
  交易协议: "《Acordo de Negociação》",
  带单协议: "《Acordo de Copiagem》",
  追加跟单本金: "Adicionar Capital de Copiagem",
  提示: "Aviso:",
  提示信息: "A divisão de lucro é liquidada todos os dias à meia-noite e concluída antes das 1h. Após a liquidação, os lucros serão automaticamente depositados em sua conta de contratos; se você tiver posições copiadas durante o período de liquidação, o lucro será liquidado no próximo dia útil",
  合约跟单: "Copiagem de Contratos",
  跟单文字: "Na Biking, ganhe dinheiro junto com os melhores traders do mundo",
  查看牛人实盘: "Ver a conta real dos Traders",
  捕捉市场信号: "Capturar sinais do mercado",
  复制高手收益: "Copiar os lucros dos traders experientes",
  跟单指南: "Guia de Copiagem",
  跟单广场: "Praça de Copiagem",
  跟单总收益: "Lucro Total da Copiagem",
  丰厚分润收入: "Receita de Divisão de Lucro",
  更多平台曝光: "Mais exposição na plataforma",
  专属交易徽章: "Emblema de Trading Exclusivo",
  成为Biking带单交易员: "Torne-se um Trader Copiador na Biking",
  享受Biking带单交易员的独家福利: "Desfrute dos benefícios exclusivos de ser um Trader Copiador na Biking",
  平台奖励: "Recompensa da Plataforma",
  联系方式: "Informações de Contato",
  简介: "Introdução",
  请输入简介: "Insira uma introdução",
  交易能力证明: "Comprovação de Habilidade de Negociação (opcional)",
  选择周期: "Selecione um período de lucro de mais de 30 dias, estatísticas de negociação, etc.; se não for carregado, verificaremos seu histórico de negociações na EuYi. Você pode fazer upload de até 3 imagens, cada uma com tamanho máximo de 10 MB.",
  我已阅读并同意: "Li e concordo com",
  跟单交易服务条款: 'Termos de Serviço para Copiar Transações',
  立即申请: 'Aplicar Agora',
  请输入联系方式: 'Por favor, insira suas informações de contato',
  联系方式不正确: 'Informações de contato incorretas!',
  邮箱格式不正确: 'Formato de e-mail incorreto',
  请输入简介信息: 'Por favor, insira uma breve descrição',
  请确认勾选协议: 'Por favor, confirme a seleção dos termos do serviço',
  上传头像图片限制: 'Limite de tamanho de imagem para avatar é de 10 MB!',
  最大限制: 'Limite máximo atual para carregar 3 arquivos',
  带单交易员招募中: 'Recrutamento de traders para Copiar Transações, aproveite o lucro de 12%',
  跟单成功: 'Transações copiadas com sucesso',
  昵称: 'Apelido',
  请输入昵称: 'Por favor, insira um apelido',
  申请交易员已提交: 'A candidatura para se tornar um trader foi enviada, aguarde a aprovação'
};

export const hyy = {
  bkt: "Não abrir",
  wqdkt: "Confirmo a abertura",
  kt12: "1. Antes de participar, é importante que você entenda completamente o conhecimento básico sobre negociação de contratos de criptomoedas, os riscos associados à negociação de derivativos e todas as regras relacionadas à negociação de derivativos.",
  kt13: "2. Os riscos mencionados acima são apenas exemplos, e não abrangem todos os riscos envolvidos na negociação de derivativos de ativos digitais. Antes de participar da negociação de derivativos de ativos digitais, você também deve entender e conhecer outros riscos possíveis.",
  kt14: "3. Sinceramente, esperamos e aconselhamos que os investidores decidam se vão ou não participar dessa negociação de contratos com base em sua própria capacidade de suportar riscos e alocação razoável de seus ativos digitais.",
  kt0: "Prezado usuário:",
  kt1: "Você ainda não abriu uma conta de contrato e permissões de negociação de contratos. Por favor, leia o seguinte conteúdo antes de decidir abrir:",
  kt2: "1. Ao negociar no mercado de contratos, se a tendência de preços do mercado for desfavorável e resultar em insuficiência de margem em sua posição, a conta de contrato perpétuo do BiKing irá liquidar sua posição de acordo com as regras do sistema e divulgar os detalhes da liquidação.",
  kt3: "2. Você deve ler atentamente e cumprir as regras de negócios do contrato perpétuo do BiKing, entender o mecanismo e o funcionamento do contrato, e estar ciente de todos os riscos do mercado.",
  kt4: "3. O contrato perpétuo do BiKing é um sistema de negociação de contrato, e o lucro e a perda da sua posição são afetados pela flutuação do mercado de contratos. Quando houver grandes perdas, sua posição pode ser liquidada no sistema de negociação de contratos. Portanto, você deve decidir suas próprias ações de negociação com base nas condições do mercado e assumir total responsabilidade pelo seu lucro e prejuízo, e, com base nisso, o BiKing não assume nenhuma responsabilidade garantida ou pré-definida.",
  kt5: "4. Em algumas circunstâncias extremas do mercado, você pode ter dificuldades ou ser incapaz de fechar posições em aberto. Por exemplo, quando seus lucros estão em primeiro lugar no PnL (lucro e perda) efetivo em todo o mercado de contratos, e a contraparte não possui fundos de seguro suficientes para cobrir suas perdas de liquidação.",
  kt6: "5. A negociação de derivativos de ativos digitais pode enfrentar riscos regulatórios em certas jurisdições. Antes de negociar, você deve fazer uma avaliação cuidadosa da regulamentação local relevante. Devido a mudanças nas leis, regulamentos e políticas em países e regiões relevantes, alterações nas regras de negociação de exchanges de contratos e medidas emergenciais, o BiKing divulgará avisos com antecedência. Suas posições abertas podem não ser mantidas, mas o saldo de margem e lucros será resgatado.",
  kt7: "6. Devido a razões que estão além do controle da plataforma, como terremotos, inundações, incêndios e outros eventos de força maior, ou falhas nos sistemas de computador e comunicação, suas ordens podem não ser executadas ou executadas parcialmente, resultando em perdas que você deve suportar.",
  kt8: "7. A negociação de 'hedge' (cobertura) é tão arriscada quanto a negociação especulativa, sujeita a riscos causados por flutuações de preços.",
  kta9: "8. Se você não tiver concluído a verificação de identidade ou não tiver ativado a verificação do Google, ou se emprestar sua conta a outra pessoa para operar, a segurança de sua margem de contrato pode ser afetada.",
  kta10: "9. Em algumas circunstâncias extremas do mercado, você pode ter dificuldades ou ser incapaz de fechar posições em aberto. Por exemplo, quando seus lucros estão em primeiro lugar no PnL (lucro e perda) efetivo em todo o mercado de contratos, e a contraparte não possui fundos de seguro suficientes para cobrir suas perdas de liquidação.",
  kt9: "Li atentamente e estou disposto a assumir os riscos.",
  kt10: "Abrir conta de contrato e permissões de negociação de contratos",
  zjhz: "Transferência de fundos",
  ljhz: "Transferir agora",
  qx: "Cancelar transferência",
  khz: "Disponível para transferência",
  qxz: "Selecione",
  bz: "Moeda",
  c: "De",
  zz: "Para",
  sl: "Quantidade",
  qb: "Tudo",
  ktcg: "Abertura bem-sucedida",
  ktsb: "Falha na abertura",
  hzcg: "Transferência bem-sucedida",
  hzsb: "Falha na transferência",
  wyyd: "Por favor, confirme que leu o aviso", //Não foi possível identificar o texto completo, então apenas o contexto foi traduzido
  tc: "Sair",
  warning1: "Selecione a moeda",
  warning2: "Conta de saída não pode estar vazia",
  warning3: "Conta de destino não pode estar vazia",
  warning4: "Insira um número não maior que a quantidade disponível para transferência",
  gb: "Fechar",
  openSuccess: "Você abriu com sucesso a negociação de contratos",
  openSuccessTip: "Por favor, transfira fundos para a conta de contrato",
  warning5: "Máximo de 4 casas decimais permitidas",
  not_get_nm: "Desculpe, a promoção do Código de Lama (NFT) já acabou, essa transferência não gerará Códigos de Lama",
};

export const invite = {
  yqfy: "Convite para comissão",
  yj1: "Compartilhe o link de convite, pôster de convite ou código de referência",
  yj2: "Convide amigos para se registrarem e negociarem",
  yj3: "Receba comissão das taxas de negociação",
  yqm: "Meu código de convite:",
  yqlj: "Meu link de convite:",
  fz: "Copiar",
  fzcg: "Copiado com sucesso",
  fzsb: "Falha ao copiar",
  dlck: "Ver após o login",
  rs: "Número de pessoas convidadas",
  ljbb: "Comissão acumulada de negociação de moedas (até {flag})",
  ljeft: "Comissão acumulada de negociação ETF (até {flag})",
  ljhy: "Comissão acumulada de negociação de contratos (até {flag})",
  yhm: "Nome de usuário",
  sfsm: "Verificado",
  tjsj: "Data de indicação",
  zsy: "Lucro total (até {flag})",
  s: "Sim",
  f: "Não",
  djjz: "Clique para carregar mais",
  ckmx: "Ver detalhes",
  pm: "Classificação",
  zyqr: "Nº de pessoas convidadas no mês",
  zfyj: "Comissão mensal (até {flag})",
  ckbd: "Ver a lista completa",
  rlues1: "Convide amigos para se registrarem e receba comissão a longo prazo.",
  rlues2:
  "Convide amigos para se registrarem e estabeleça um relacionamento de indicação. Você receberá comissão das taxas de negociação de moedas e ETFs realizadas pelos seus amigos. Não há limite para os ganhos de comissão de indicação.",
  rlues3: "Regras e proporções de comissão de indicação",
  jylx: "Tipo de negociação",
  yqrfy: "Comissão para o indicador",
  yqgxyxq: "Validade do relacionamento de indicação",
  sixMonth: "6 meses",
  yj: "Permanente",
  bbjy: "Negociação de moedas",
  hyjy: "Negociação de contratos",
  etfjy: "Negociação de ETFs alavancados",
  gxsj: "Dados atualizados toda segunda-feira",
  xts: "Dica",
  ts1: "Seus amigos devem inserir seu código de convite durante o registro para que seja considerado um convite bem-sucedido!",
  ts2: "Use o celular para escanear o código QR à esquerda e envie o link para convidar usuários de forma rápida.",
  tgzsy: "Lucro total da promoção (até {flag})",
  cz: "Operações",
  fymx: "Detalhes da comissão >",
  zwsj: "Nenhum registro encontrado",
  yh: "Usuário",
  hqyj: "Comissão de convite recebida",
  ysm: "Verificado",
  wsm: "Não verificado",
  hyfymx: "Detalhes de comissão do amigo convidado",
  fylx: "Tipo de comissão",
  fyje: "Valor da comissão",
  fysj: "Data da comissão",
  mxsyb: "Tabela de lucros detalhados",
  zwjy: "Esse amigo ainda não fez negociações, então não há comissão de taxa de negociação",
  bczxc: "Salvar no álbum",
  rlues4: "Devido a instabilidades na rede, alguns usuários podem experimentar atrasos na recepção das comissões. Por favor, tenha paciência.",
  moreRules: "Ver regras detalhadas",
};


// WEBPACK FOOTER //
// ./src/i18n/lang/merchandiser/pt_BR.js